module.exports = __webpack_public_path__ + "img/play-store.1f21e894.png";